// City slugs used for local SEO landing pages (sync with Django CITY_LOCATIONS)
export const CITY_SLUGS = new Set([
  'ahmedabad', 'surat', 'vadodara', 'bhavnagar', 'kutch', 'himmatnagar', 'vatva',
  'kathwada', 'kalol', 'gandhidham', 'mehsana', 'chhatral', 'pune', 'bangalore',
  'mangalore', 'mumbai', 'hyderabad', 'chennai', 'noida', 'bhopal', 'faridabad',
  'indore', 'rohtak', 'ambala', 'gurugram', 'jaipur', 'udaipur', 'gujarat',
  'maharashtra', 'rajasthan', 'pan-india',
]);
